import { lazy } from "react";
import type { AppRoute } from "@/types/routes";

const Home = lazy(() => import("@/components/Home"));
const About = lazy(() => import("@/components/About"));
const Contact = lazy(() => import("@/components/Contact"));
const AdminPrograms = lazy(() => import("@/admin/AdminPrograms"));
const AdminModules = lazy(() => import("@/admin/AdminModules"));
const AdminProgramModules = lazy(() => import("@/admin/AdminProgramModules"));
const AdminProgramGroups = lazy(() => import("@/admin/AdminProgramGroups"));
const AdminModuleEditor = lazy(() => import("@/admin/AdminModuleEditor"));
const AdminOrganizations = lazy(() => import("@/admin/AdminOrganizations"));
const AdminOrganizationGroups = lazy(() => import("@/admin/AdminOrganizationGroups"));
const AdminOrganizationManagers = lazy(() => import("@/admin/AdminOrganizationManagers"));
const Beveiligingsbeleid = lazy(() => import("@/components/Beveiligingsbeleid"));
const Cookiebeleid = lazy(() => import("@/components/Cookiebeleid"));
const Me = lazy(() => import("@/components/Me"));

const Programs = lazy(() => import("@/components/Programs"));
const Courses = lazy(() => import("@/components/Courses"));
const ModulePage = lazy(() => import("@/components/ModulePage"));
const AccessDenied = lazy(() => import("@/components/AccessDenied"));

// Manager components
const ManagerDashboard = lazy(() => import("@/manager/ManagerDashboard"));
const ManagerStatistics = lazy(() => import("@/manager/ManagerStatistics"));
const ManagerPrograms = lazy(() => import("@/manager/ManagerPrograms"));
const ManagerGroups = lazy(() => import("@/manager/ManagerGroups"));
const ManagerGroupMembers = lazy(() => import("@/manager/ManagerGroupMembers"));
const ManagerOnboarding = lazy(() => import("@/manager/ManagerOnboarding"));

const AppRoutes = [
    { index: true, element: <Home />, layout: "noheader" },
    { path: "/about", element: <About />, layout: "noheader", titleCode: "OverMalenco" },
    { path: "/contact", element: <Contact />, layout: "noheader", titleCode: "Contact" },

    { path: "/me", element: <Me />, layout: "default" },
    { path: "/courses", element: <Courses />, layout: "default", titleCode: "Programma's" },
    { path: "/access-denied", element: <AccessDenied />, layout: "default", titleCode: "AccessDeniedPageTitle" },
    { path: "/programs", element: <Programs />, layout: "default", titleCode: "Programma's" },
    { path: "/programs/:programId/modules/:moduleId", element: <ModulePage />, layout: "default", titleCode: "Module" },

    { path: "/admin/programs", element: <AdminPrograms />, layout: "admin", titleCode: "AcademyBeheer" },
    { path: "/admin/modules", element: <AdminModules />, layout: "admin", titleCode: "AcademyBeheer" },
    { path: "/admin/organizations", element: <AdminOrganizations />, layout: "admin", titleCode: "AcademyBeheer" },
    { path: "/admin/organizations/:tenantId/groups", element: <AdminOrganizationGroups />, layout: "admin", titleCode: "AcademyBeheer" },
    { path: "/admin/organizations/:tenantId/managers", element: <AdminOrganizationManagers />, layout: "admin", titleCode: "AcademyBeheer" },
    { path: "/admin/programs/:programId/modules", element: <AdminProgramModules />, layout: "admin", titleCode: "AcademyBeheer" },
    { path: "/admin/programs/:programId/groups", element: <AdminProgramGroups />, layout: "admin", titleCode: "AcademyBeheer" },

    { path: "/admin/modules/:moduleId/editor", element: <AdminModuleEditor />, layout: "admin", titleCode: "AcademyBeheer" },

    { path: "/manager", element: <ManagerDashboard />, layout: "manager", titleCode: "ManagerBeheer" },
    { path: "/manager/onboarding", element: <ManagerOnboarding />, layout: "manager", titleCode: "ManagerBeheer" },
    { path: "/manager/statistics", element: <ManagerStatistics />, layout: "manager", titleCode: "ManagerBeheer" },
    { path: "/manager/programs", element: <ManagerPrograms />, layout: "manager", titleCode: "ManagerBeheer" },
    { path: "/manager/groups", element: <ManagerGroups />, layout: "manager", titleCode: "ManagerBeheer" },
    { path: "/manager/groups/:groupId/members", element: <ManagerGroupMembers />, layout: "manager", titleCode: "ManagerBeheer" },

    { path: "/beveiligingsbeleid", element: <Beveiligingsbeleid />, layout: "default", titleCode: "Beveiligingsbeleid" },
    { path: "/cookiebeleid", element: <Cookiebeleid />, layout: "default", titleCode: "Cookiebeleid" },
    { path: "*", element: <div>Pagina niet gevonden</div> },
] as const satisfies readonly AppRoute[];

export default AppRoutes;
